import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Label,
  Input,
  Card,
  FormFeedback,
  Form
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { putCostCentersAdminUpdate, getOrgsAdmin } from "../../../helpers/api_rombo_helper";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import Select from "react-select";
import * as Yup from 'yup';
import { useFormik } from "formik";

const Step1 = ({ step, errorAlert, token, setErrorAlert, errorAlertMessage, setErrorAlertMessage, name, setName, description, infoUser, setDescription, company, setCompany, id, companyName }) => {

  const history = useNavigate();
  const dispatch = useDispatch();
  const [listCompanies, setListCompanies] = useState([]);
  const [disabledBtnCreate, setDisabledBtnCreate] = useState(true);

  useEffect(() => {
    if(infoUser.is_staff) onGetOrgsAdmin();
  }, [dispatch, infoUser]);

  const autoformik = useFormik({
    initialValues: {
      name: name,
      description: description
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Required"),
      description: Yup.string().required("Required")
    })
  });

  useEffect(() => {
    if(autoformik.values.name && autoformik.values.description){
      setDisabledBtnCreate(false)
    }else{
      setDisabledBtnCreate(true)
    }
  }, [autoformik]);

  const editCostCenter = () => {
    let body = {
      name: autoformik.values.name,
      description: autoformik.values.description,
      partner_id: String(company.value),
    }
    putCostCentersAdminUpdate(token, id, body)
      .then((resp) => {
        localStorage.setItem("notify", "true")
        localStorage.setItem("headerText", i18n.t("UpdatedCostCenter"))
        localStorage.setItem("bodyText", i18n.t("SuccessUpdateCostCenter", { name: autoformik.values.name }))
        history("/cost-centers");
      })
      .catch((error) => {
        console.error("Error - putCostCentersAdminUpdate ", error);
        setErrorAlert(true)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
        if(error.code == 500) setErrorAlertMessage(i18n.t("NetworkError"))
      })
  }

  const onGetOrgsAdmin = () => {
    let partnersInfo = [];
    getOrgsAdmin(token)
      .then((response) => {
        response.map((item) => {
          partnersInfo.push({ label: item.name, value: item.partner_id });
        });
        setListCompanies([...partnersInfo]);
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      });
  };

  return (
    <Fragment>
      <CardBody>
        <Row>
          <Form className="gy-2 gx-3" onSubmit={autoformik.handleSubmit}>
            <Row>
              <Col xxl={6} md={6} xs={12} className="">
                {infoUser.is_staff && (
                  <Col xxl={12} md={12} xs={12} className="">
                    <Label className="employees-form-subtitle" htmlFor="nameInput">{i18n.t("Partner")}</Label>
                    <Card className="mb-0">
                      <Select
                        name="company"
                        placeholder={i18n.t("SelectPartnerName")}
                        options={listCompanies}
                        isDisabled={true}
                        className="select2-selection"
                        value={listCompanies.filter((item) => item.value == company.value )}
                        onChange={(selectedOption) => {
                          setCompany(selectedOption);
                        }}
                      />
                    </Card>
                  </Col>
                )}
                <Col xxl={6} md={6} xs={12}>
                  <div className="col-sm-auto mb-2">
                    <p/>
                    <Label className="employees-form-subtitle" htmlFor="nameInput">
                      {i18n.t("CostCenterName")}
                    </Label>        
                    <Input
                      type="text"
                      name="name"
                      className="employees-form-input"
                      id="nameInput"
                      placeholder={i18n.t("CostCenterName")}
                      value={autoformik.values.name ||= name}
                      onChange={autoformik.handleChange}
                      onBlur={autoformik.handleBlur}
                      invalid={
                        autoformik.touched.name && autoformik.errors.name ? true : false
                      }
                    />
                    {autoformik.errors.name && autoformik.touched.name && (
                      <FormFeedback type="invalid">
                        {autoformik.errors.name}
                      </FormFeedback>
                    )}
                  </div>
                </Col>
                <Col xxl={6} md={6} xs={12}>
                  <div className="col-sm-auto mb-2">
                    <Label className="employees-form-subtitle" htmlFor="descriptionInput">
                      {i18n.t("CostCenterDescription")}
                    </Label>              
                    <Input
                      type="textarea"
                      name="description"
                      className="cost-center-description-input"
                      id="descriptionInput"
                      placeholder={i18n.t("CostCenterDescription")}
                      value={autoformik.values.description ||= description}
                      onChange={autoformik.handleChange}
                      onBlur={autoformik.handleBlur}
                      invalid={
                        autoformik.touched.description && autoformik.errors.description ? true : false
                      }
                    />
                    {autoformik.errors.description && autoformik.touched.description && (
                      <FormFeedback type="invalid">
                        {autoformik.errors.description}
                      </FormFeedback>
                    )}
                  </div>
                </Col>
              </Col>
            </Row>
          </Form>
          <Col xxl={2} md={2} xs={12} className="d-flex">
            <button
              onClick={() => editCostCenter()}
              disabled={ disabledBtnCreate }
              className="btn btn-request fs-11">{
                i18n.t("SaveData")}
            </button>
            <Link to={`/cost-centers`} className="btn btn-go-back border fs-11 mx-2">
              {i18n.t("Back")}
            </Link>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  )
}

export default Step1;
